<template>
  <div class="errors-unlinked">
    <div v-for="(message, i) in messages" :key="`error-unlinked-${i}`">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VFormErrorsUnlinked',
  props: {
    errors: {
      type: Object,
      default() {
        return {};
      },
    },
    formChildren: {type: Array, required: true},
  },
  computed: {
    messages() {
      if (!this.errors || !this.formChildren.length) return null;

      let props = this.formChildren.filter((child) => child.$options.name === 'VFormItem').map((child) => child.prop);
      let errorKeys = Object.keys(this.errors).filter((key) => !props.includes(key));
      if (!errorKeys.length) return null;

      return errorKeys.map((key) => this.errors[key].join(' '));
    },
  },
};
</script>

<style scoped>
.errors-unlinked {
  margin-top: 1em;
  color: var(--input-text-color-error);
  font-size: 0.75rem;
}
</style>
